// extracted by css-extract-rspack-plugin
export default {"authorLoginLink":"IssueBodyHeaderAuthor-module__authorLoginLink__sLcQc0c"};